import PayerEditPage from './PayerEditPage'

export default PayerEditPage
